import { Button, Checkbox, Icon, Table } from "semantic-ui-react";
import ScrollableTable from "components/TableWrapper";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useState } from "react";
import { sendRoomReadyNotificationEmail } from "services/roomReadys";
import { parseBpCommentString } from "utils/commentParser";

export default function ListTable(props: any): JSX.Element {
  const { hotel } = props;
  const [state, setState] = useState<any>({
    column: null,
    direction: null,
  });

  const {
    roomReadys,
    bookings,
    setBookings,
    popup,
    setPopup,
    filter,
    setFilter,
    fetchCount,
    setFetchCount,
    bookingFilter,
    queryString,
    waitForRoom,
    setRoomReady,
    setQrCode,
  } = props;

  const data = props.isBooking ? bookings : roomReadys;
  const hotelName = props.hotel?.getHotelName();
  const showPhoneNumber =
    hotelName?.toLowerCase()?.includes("parklane") ||
    hotelName?.includes("bluepin");

  const handleSort = (sortInfo: any) => {
    const { sort, column, value, direction } = sortInfo;
    if (!sort) return;

    const { type } = sort;
    // console.log(column, value, type, data);

    if (column === value) {
      const tmp = data;
      data.splice(0, data.length, ...tmp.slice().reverse());

      setState({
        ...state,
        direction: direction === "ascending" ? "descending" : "ascending",
      });
      return;
    }

    const sortedData = data.sort((a: any, b: any) => {
      if (!b[sort.key || value] || !a[sort.key || value]) return;
      if (type === "number") return b[sort.key || value] - a[sort.key || value];
      if (type === "string")
        return b[sort.key || value].localeCompare(a[sort.key || value]);
      if (type === "date")
        return new Date(b[value]).getTime() - new Date(a[value]).getTime();
    });
    data.splice(0, data.length, ...sortedData);
    setState({ ...state, column: value, direction: "ascending" });
  };

  return (
    <ScrollableTable>
      <Table.Header>
        <Table.Row textAlign="center">
          <Table.HeaderCell
            sorted={
              state.column === "confirmationNumber" ? state.direction : null
            }
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "confirmationNumber" },
              })
            }
            width="1"
          >
            Confirmation No.
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "lastName" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "string", value: "lastName" },
              })
            }
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "checkInDate" ? state.direction : null}
            onClick={() =>
              handleSort({
                ...state,
                sort: { type: "date", value: "checkInDate" },
              })
            }
          >
            Check In / Out time
          </Table.HeaderCell>
          <Table.HeaderCell
            width="1"
            sorted={state.column === "email" ? state.direction : null}
            onClick={() =>
              handleSort({ ...state, sort: { type: "string", value: "email" } })
            }
          >
            Email
          </Table.HeaderCell>
          {showPhoneNumber ? (
            <Table.HeaderCell
              width="2"
              sorted={state.column === "phone" ? state.direction : null}
              onClick={() =>
                handleSort({
                  ...state,
                  sort: { type: "string", value: "phone" },
                })
              }
            >
              Phone
            </Table.HeaderCell>
          ) : (
            <></>
          )}
          <Table.HeaderCell width="2">
            <div>Actions</div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data.length === 0 ? (
          <>no records</>
        ) : (
          data
            .filter((item: any) => {
              const { filtering } = filter;

              if (Object.values(queryString).some((value) => value)) {
                return !!Object.keys(item).find((key) => {
                  // console.log(typeof item?.[key], item[key])

                  const found =
                    typeof item?.[key] === "string" &&
                    item?.[key]
                      ?.toLowerCase()
                      .includes(queryString?.["any"]?.toLowerCase());

                  const byCheckInDate =
                    dayjs(queryString["checkInDate"]).isValid() &&
                    dayjs(item["checkInDate"]).isAfter(
                      dayjs(queryString["checkInDate"]).subtract(1, "days")
                    );

                  return !dayjs(queryString["checkInDate"]).isValid()
                    ? found
                    : found && byCheckInDate;
                });
              }

              if (props.isBooking) {
                return !roomReadys.find(
                  ({ bookingNumber }: any) =>
                    bookingNumber === item.confirmationNumber
                );
              }

              return item;
            })
            .map((item: any, i: number) => {
              const fullName = `${item?.profile?.lastName || ""} ${
                item?.profile?.firstName || ""
              }`;
              const checkInTime = dayjs(item?.checkInDate || "").isValid()
                ? dayjs(item.checkInDate).format("YYYY-MM-DD HH:mm:ss")
                : "";
              const checkOutTime = dayjs(item?.checkOutDate || "").isValid()
                ? dayjs(item.checkOutDate).format("YYYY-MM-DD HH:mm:ss")
                : "";
              const confirmationNumber =
                item.bookingNumber || item.confirmationNumber;

              const showSentAt: boolean =
                hotelName?.toLowerCase()?.includes("parklane") ||
                hotelName?.toLowerCase()?.includes("bluepin")
                  ? !item?.sendAt ||
                    (!item?.email && !item?.profile?.phoneNumber?.number)
                  : !item?.sendAt || !item?.email;

              return (
                <Table.Row textAlign="center" key={i}>
                  <Table.Cell>{confirmationNumber}</Table.Cell>
                  <Table.Cell>
                    <div className="w-max">{fullName}</div>
                  </Table.Cell>
                  <Table.Cell width={10} style={{ width: "10rem" }}>
                    <div className="w-max">
                      <div className="flex justify-between">
                        <div className="mr-2">IN:</div>
                        <div>{checkInTime}</div>
                      </div>
                      <hr />
                      <div className="flex justify-between">
                        <div className="mr-2">OUT:</div>
                        <div>{checkOutTime}</div>
                      </div>
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div className="flex flex-wrap w-min">
                      {
                        item?.email || ""
                        // item?.email ||
                        // item?.profile?.email?.email
                      }
                    </div>
                  </Table.Cell>
                  {showPhoneNumber ? (
                    <Table.Cell>
                      <div className="flex">
                        {item?.profile?.phoneNumber?.number || ""}
                      </div>
                    </Table.Cell>
                  ) : (
                    <></>
                  )}
                  <Table.Cell>
                    <div className="flex justify-center gap-1">
                      <Icon
                        style={{ margin: "auto 0" }}
                        className="w-min cursor-pointer"
                        color="yellow"
                        name="edit"
                        onClick={() => {
                          setRoomReady({
                            ...item,
                            comments: item.comments,
                            email: item?.email,
                            phoneNumber: item?.phoneNumber,
                            isNew: false,
                          });
                          // setRoomReady({ ...item, isNew: false })
                          setPopup({ ...popup, addWaitForRoom: true });
                        }}
                      />
                      <Button
                        className="w-min"
                        size="tiny"
                        color={showSentAt ? "yellow" : undefined}
                        content={
                          showSentAt
                            ? `Send`
                            : `Sent at ${dayjs(item?.sendAt).format(
                                "YYYY-MM-DD HH:mm:ss"
                              )}`
                        }
                        icon="paper plane"
                        labelPosition="left"
                        style={{ marginTop: ".5rem", padding: ".3rem" }}
                        onClick={async () => {
                          try {
                            const email = item?.email || "";
                            const phoneNumber = item?.phoneNumber || "";

                            const bothMissing =
                              !item.email && !item.phoneNumber;

                            if (bothMissing) {
                              return toast.error(
                                `Email is missing, failed to send notification`
                              );
                            }

                            const sendNotiReqData = {
                              ...item,
                              hotelId: hotel.id,
                              sendAt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                            };

                            // console.log({hotel:hotel.hotelName,'parklane':hotel?.hotelName?.toLowerCase()?.includes('parklane')})
                            if (!hotelName?.toLowerCase()?.includes("parklane"))
                              delete sendNotiReqData.phoneNumber;
                            await sendRoomReadyNotificationEmail(
                              sendNotiReqData
                            );

                            toast.success(
                              <div style={{ textAlign: "left" }}>
                                <div> {`email sent to: ${email}`} </div>
                                {showPhoneNumber ? (
                                  <div>
                                    {" "}
                                    {`whatsapp sent to: ${phoneNumber}`}{" "}
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            );

                            setFetchCount(fetchCount + 1);
                          } catch (err: any) {
                            console.log("send err:", err.message);
                            toast.error(
                              <div style={{ textAlign: "left" }}>
                                <div> {`Failed to send...`} </div>
                                <div> {`message: ${err.message}`} </div>
                              </div>
                            );
                          }
                        }}
                      />
                      {!props.isBooking && (
                        <Icon
                          style={{ margin: "auto 0" }}
                          className="w-min cursor-pointer"
                          disabled={item.isBooking}
                          color="red"
                          name="trash alternate"
                          onClick={() => {
                            setRoomReady(item);
                            setPopup({ ...popup, delete: true });
                          }}
                        />
                      )}
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            })
        )}
      </Table.Body>
    </ScrollableTable>
  );
}
